import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const cardTheme = theme.investment.breakdown.card;

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.background,
      borderRadius: constants.radius.view,
      width: 124,
      display: "flex",
      flexDirection: "column",
      paddingTop: 28,
      paddingBottom: 28,
      paddingLeft: spacing.m,
      paddingRight: spacing.m,
      userSelect: "none",
    },
    text: {
      fontWeight: "bold",
      fontSize: 14,
    },
    neutral: {
      color: cardTheme.neutral,
    },
    positive: {
      color: cardTheme.positive,
    },
    negative: {
      color: cardTheme.negative,
    },
    exclusive: {
      display: "inline-block",
    },
  };

  return styles;
};
